<template>
  <div class="wb-grid-row">
    <div
      class="otb-summary__teaser-image-wrapper wb-grid-col-mq1-12 wb-grid-col-mq3-5"
    >
      <img class="otb-summary__teaser-image" :src="imageSrc" />
    </div>
    <div
      class="otb-summary__teaser-content wb-grid-col-mq1-12 wb-grid-col-mq3-7"
    >
      <div class="otb-summary__teaser-body">
        <h3 class="otb-summary__teaser-title wb-type-heading-s">
          {{ title }}
        </h3>

        <p class="wb-type-copy">{{ message }}</p>
      </div>
      <div class="otb-summary__teaser-actions">
        <a
          @click="trackEvent"
          :href="buttonLink"
          class="wb-button wb-button--large"
          :class="buttonClass"
          >{{ buttonLabel }}</a
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { EventTrackingInfo } from '../../../../models/entities/tracking.model';
import TrackingService from '../../../../services/tracking.service';
import {
  TRACKING_EVENT_ACTION,
  TRACKING_EVENT_CATEGORY,
} from '../../../../models/constants';
import { computed, defineComponent } from 'vue';

import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  name: 'otb-summary-teaser',
  props: {
    buttonLabel: String as () => string | TranslateResult,
    buttonLink: String,
    buttonType: {
      type: String,
      default: 'primary',
    },
    imageSrc: String,
    message: String as () => string | TranslateResult,
    title: String as () => string | TranslateResult,
  },
  setup(props) {
    const buttonClass = computed((): string => {
      return `wb-button--${props.buttonType}`;
    });

    const trackEvent = () => {
      const event: EventTrackingInfo = {
        action: TRACKING_EVENT_ACTION.MME_LOGIN,
        category: TRACKING_EVENT_CATEGORY.LINK,
        name: TRACKING_EVENT_CATEGORY.LINK,
      };
      TrackingService.trackEvent(event);
    };

    return { buttonClass, trackEvent };
  },
});
</script>
<style lang="scss" src="./summary-teaser.scss"></style>
